<script lang="ts">
	import { Icon, login } from '@enzianweb/shared';
	import { page } from '$app/state';

	interface Props {
		link: string;
		externalLink?: string | null;
		name: string;
		icon?: string | null;
		width?: number;
		height?: number;
	}

	let { link, externalLink = null, name, icon = null, width = 20, height = 20 }: Props = $props();
</script>

{#if !externalLink}
	<a
		href={link}
		class:selected={page.url.pathname == link}
		onclick={() => {
			const navGrid = document.getElementById('nav-grid');

			if (navGrid?.classList.contains('active')) {
				navGrid?.classList.remove('active');
			} else {
				navGrid?.classList.add('active');
			}
		}}
		class="mx-4 py-2 border-b h-full border-transparent flex items-center
		 dark:text-white hover:text-secondary-200 dark:hover:text-secondary-500
		  hover:border-b-secondary-200 dark:hover:border-secondary-500
		  hover:fill-secondary-200 dark:fill-white dark:hover:fill-secondary-500
		  selected:text-secondary-200 selected:fill-secondary-200 selected:dark:text-secondary-500 selected:dark:fill-secondary-500"
	>
		{#if icon}<Icon name={icon} classInfo="mr-2" />{/if}
		<p class="text-lg truncate nav-text" class:sysadmin={$login?.systemAdmin}>
			{name}
		</p>
	</a>
{:else}
	<a
		href={externalLink}
		target="_blank"
		class="mx-4 py-2 border-b h-full border-transparent flex items-center dark:text-white hover:text-secondary-200 dark:hover:text-secondary-500 hover:border-b-secondary-200 dark:hover:border-secondary-500 hover:fill-secondary-200 dark:fill-white dark:hover:fill-secondary-500"
	>
		{#if icon}<Icon name={icon} classInfo="mr-2" />{/if}
		<p class="text-lg truncate nav-text" class:sysadmin={$login?.systemAdmin}>
			{name}
		</p>
	</a>
{/if}

<style>
	.nav-text {
		display: block;
	}

	@media (min-width: 780px) {
		.nav-text {
			display: none;
		}
	}

	@media (min-width: 1360px) {
		.nav-text:not(.sysadmin) {
			display: block;
		}
	}

	@media (min-width: 1760px) {
		.nav-text.sysadmin {
			display: block;
		}
	}
</style>
